import { INITIAL_PALLET_AMOUNTS } from 'constants/initialPalletAmounts';
import { PalletAmount } from 'interfaces';

export const countPalletsAmount = (pallets: PalletAmount[]) =>
   pallets.reduce((palletsTotalAmount, palletsItem) => {
      palletsTotalAmount[palletsItem.palletType] += palletsItem.amount;
      return palletsTotalAmount;
   }, INITIAL_PALLET_AMOUNTS());
